class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

renderContents(parsedState) {
  const inner = this.querySelector('.drawer__inner');
  if (inner && inner.classList.contains('is-empty')) {
    inner.classList.remove('is-empty');
  }

  this.productId = parsedState.id;

  this.getSectionsToRender().forEach((section) => {
    const sectionElement = section.selector
      ? document.querySelector(section.selector)
      : document.getElementById(section.id);

    if (!sectionElement) return;
    sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
  });

  /* --- SYNC FLOATING NAV BUBBLE --- */
  try {
    const newCount = typeof parsedState.item_count === 'number'
      ? parsedState.item_count
      : parseInt(parsedState.item_count || 0, 10);

    const navBubble = document.querySelector('.dl-floating-nav .cart-count-bubble');
    if (navBubble) {
      const countSpan = navBubble.querySelector('.cart-count');
      if (countSpan) countSpan.textContent = newCount;

      if (newCount > 0) {
        navBubble.classList.remove('hidden');
      } else {
        navBubble.classList.add('hidden');
      }
    }
  } catch (err) {
    console.warn('Cart bubble sync failed', err);
  }
  /* --- END SYNC --- */

  setTimeout(() => {
    const overlay = this.querySelector('#CartDrawer-Overlay');
    if (overlay) overlay.addEventListener('click', this.close.bind(this));
    this.open();
  });
}


  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
  /* --- FORCE SYNC OF FLOATING NAV BUBBLE ON REMOVE, ADD, CHANGE --- */
updateQuantity(line, quantity) {
  const body = JSON.stringify({
    line,
    quantity,
    sections: this.getSectionsToRender().map((section) => section.section),
    sections_url: window.location.pathname
  });

  fetch(`${routes.cart_update_url}`, {
    ...fetchConfig(),
    body
  })
    .then((response) => response.json())
    .then((parsedState) => {
      this.renderContents(parsedState);

      /* SYNC FLOATING NAV CART BUBBLE */
      try {
        const newCount =
          typeof parsedState.item_count === 'number'
            ? parsedState.item_count
            : parseInt(parsedState.item_count || 0, 10);

        const bubble = document.querySelector('.dl-floating-nav .cart-count-bubble');
        if (bubble) {
          const span = bubble.querySelector('.cart-count');
          if (span) span.textContent = newCount;

          if (newCount > 0) {
            bubble.classList.remove('hidden');
            bubble.style.display = 'flex';
          } else {
            bubble.classList.add('hidden');
            bubble.style.display = 'none';
          }
        }
      } catch (err) {
        console.warn('Floating nav bubble sync error:', err);
      }
      /* END SYNC */
    });
}

}

customElements.define('cart-drawer-items', CartDrawerItems);
